<template>
  <!-- App.vue -->

  <v-app>
    <!--v-app-bar app dense>
      <app-topbar></app-topbar>
    </v-app-bar>
    <v-navigation-drawer app permanent expand-on-hover v-show="!show">

      <app-sidebar class="sidebar"></app-sidebar>
    </v-navigation-drawer-->

    <!-- Sizes your content based upon application components -->
    <v-container>
      <v-card>
        <v-card-title>
          สมาชิก
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
          <!-- <v-btn color="success" @click="dialog = !dialog">
            <v-icon left>mdi-plus</v-icon> สมาชิกใหม่
          </v-btn> -->
          <v-btn color="success" @click="scanQR = true">QRCode</v-btn>
        </v-card-title>
        <v-toolbar flat>
          <v-spacer></v-spacer>

          <!-- delete dialog -->
          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
              <v-card-title class="headline"
                >Are you sure you want to delete {{ editedItem.name }} ?</v-card-title
              >
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="success" @click="closeDelete">ยกเลิก</v-btn>
                <v-btn color="success" @click="deleteItemConfirm">ยืนยัน</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>

        <v-overlay :absolute="absolute" :value="responseStatus.alertStatus" z-index="99">
          <v-btn
            :color="responseStatus.color"
            @click="responseStatus.alertStatus = false"
          >
            {{ responseStatus.text }}
          </v-btn>
        </v-overlay>
        <!-- QR dialog -->
        <v-dialog
          v-model="scanQR"
          max-width="100vw"
          persistent
          @input="Object.assign({}, editedItem)"
        >
          <v-card>
            <v-card-title class="headline">Scan QRCode</v-card-title>
            <v-card-text
              ><qrcode-stream @detect="onDetected"></qrcode-stream
            ></v-card-text>
            <v-card-actions class="justify-center"
              ><v-btn color="primary darken-1" @click="scanQR = !scanQR">Close</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- delete dialog -->
        <v-dialog
          v-model="saleDialog"
          max-width="100vw"
          @input="Object.assign({}, editedItem)"
        >
          <v-card>
            <v-card-title class="headline">รายการขาย</v-card-title>
            <v-card-text>
              <sales-app
                v-bind:filterMember="editedItem"
                v-bind:cId="new Date().getTime().toString()"
                v-if="editedItem._id !== undefined"
                @closeSaleDialog="closeSaleDialog"
              ></sales-app>

              <!-- <v-btn color="primary darken-1" @click="closeSaleDialog">Close</v-btn> -->
            </v-card-text>
          </v-card>
        </v-dialog>

        <v-data-table
          :sort-by.sync="options.sortBy"
          :sort-desc.sync="options.sortDesc"
          :headers="headers"
          :items="Clients"
          :disable-sort="false"
          :footer-props="{ 'items-per-page-options': [50, 100, 200, -1] }"
          item-class="text-right"
        >
          <template v-slot:item.name="{ item }">
            {{ item.firstname }} {{ item.lastname }}
          </template>

          <template v-slot:item.createdAt="{ item }">
            {{ item.createdAt.substring(0, 10) | formatThDate }}
            <!-- {{ item.createdAt.substring(11, 19) }} -->
          </template>

          <template v-slot:item.birthdate="{ item }">
            {{ item.birthdate.substring(0, 10) | formatThDate }}
          </template>

          <template v-slot:item.status="{ item }">
            <!--v-chip :color="getColor(item.status)" dark>
              {{ item.status }}
            </v-chip-->
            <v-switch
              v-model="item.status"
              label=""
              color="success"
              value="Active"
              hide-details
              @click="clickSwitch(item)"
            ></v-switch>
          </template>
          <template v-slot:item.point="{ item }">
            <!--v-btn icon><v-icon>mdi-magnify</v-icon></!--v-btn
            -->{{ item.point }}
          </template>

          <template v-slot:item.actions="{ item }">
            <v-icon small class="mr-2" @click="addSaleOrder(item)"
              >mdi-cart-arrow-down</v-icon
            >
            <v-icon
              small
              class="mr-2"
              @click="editMember(item)"
              v-if="item.is_admin != 'Y'"
            >
              mdi-pencil
            </v-icon>
            <v-icon small @click="deleteItem(item)" v-if="item.is_admin != 'Y'">
              mdi-delete
            </v-icon>
          </template>
          <template v-slot:no-data> </template>
        </v-data-table>

        <!-- add / edit -->
        <v-navigation-drawer v-model="dialog" temporary right app width="480px">
          <v-card>
            <v-card-title>
              <v-icon @click="dialog = !dialog">mdi-close-circle</v-icon>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      v-model="editedItem.member_no"
                      label="เลขสมาชิก"
                      required
                      @input="$v.editedItem.member_no.$touch()"
                      @blur="$v.editedItem.member_no.$touch()"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      v-model="editedItem.firstname"
                      label="ชื่อ"
                      :error-messages="firstnameError"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      v-model="editedItem.lastname"
                      label="นามสกุล"
                      :error-messages="lastnameError"
                      @input="$v.editedItem.lastname.$touch()"
                      @blur="$v.editedItem.lastname.$touch()"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      v-model="editedItem.email"
                      label="อีเมล"
                      type="email"
                      :error-messages="emailError"
                      prepend-icon="mdi-mail"
                      @input="$v.editedItem.email.$touch()"
                      @blur="$v.editedItem.email.$touch()"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      v-model="editedItem.phone"
                      label="มือถือ"
                      type="text"
                      :error-messages="phoneError"
                      maxlength="10"
                      prepend-icon="mdi-cellphone"
                      @input="$v.editedItem.phone.$touch()"
                      @blur="$v.editedItem.phone.$touch()"
                      required
                      counter="10"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-select
                      :items="gender"
                      v-model="editedItem.genders"
                      item-text="value"
                      item-value="key"
                      label="เพศ"
                      required
                    ></v-select>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-menu
                      ref="birthdate"
                      v-model="birthdate"
                      :close-on-content-click="false"
                      :return-value.sync="editedItem.birthdate"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="editedItem.birthdate"
                          label="วันเกิด"
                          prepend-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          required="required"
                        ></v-text-field>
                      </template>
                      <v-date-picker v-model="editedItem.birthdate" no-title scrollable>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" @click="birthdate = false"> Cancel </v-btn>
                        <v-btn
                          color="primary"
                          @click="$refs.birthdate.save(editedItem.birthdate)"
                        >
                          OK
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>

                <!--v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      v-model="editedItem.username"
                      label="ชื่อผู้ใช้"
                      :error-messages="usernameError"
                      @input="$v.editedItem.username.$touch()"
                      @blur="$v.editedItem.username.$touch()"
                      required
                      :readonly="edit"
                    ></v-text-field>
                  </v-col>
                </v-row-->

                <!--v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      v-model="editedItem.password"
                      label="รหัสผ่าน"
                      type="password"
                      :error-messages="passwordError"
                      @input="$v.editedItem.password.$touch()"
                      @blur="$v.editedItem.password.$touch()"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      v-model="editedItem.confirm_password"
                      label="ยืนยันรหัสผ่าน"
                      type="password"
                      :error-messages="confirmPasswordError"
                      required
                      @input="$v.editedItem.confirm_password.$touch()"
                      @blur="$v.editedItem.confirm_password.$touch()"
                    ></v-text-field>
                  </v-col>
                </v-row-->

                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-select
                      :items="items_status"
                      label="สถานะ"
                      v-model="editedItem.status"
                      required
                    ></v-select>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-select
                      :items="tiers"
                      label="เทียร์"
                      v-model="tierId"
                      item-text="name"
                      item-value="_id"
                      required
                    ></v-select>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="close"> ยกเลิก</v-btn>
              <v-btn color="success" @click="save"> ยืนยัน</v-btn>
            </v-card-actions>
          </v-card>
        </v-navigation-drawer>
      </v-card>
    </v-container>
  </v-app>
</template>

<script>
import axios from "axios";
import { validationMixin } from "vuelidate";
import { required, minLength, email, sameAs } from "vuelidate/lib/validators";

//import AppSideBar from "../menu/sideBarMenu";
//import AppTopBar from "../menu/topBarMenu";
import SaleComponent from "../sales/sales-list.vue";
// eslint-disable-next-line no-unused-vars
import { QrcodeStream, QrcodeDropZone, QrcodeCapture } from "vue-qrcode-reader";
export default {
  name: "Members",
  components: {
    "sales-app": SaleComponent,
    QrcodeStream,
    /*
"app-sidebar": AppSideBar,
    "app-topbar": AppTopBar,
*/
  },
  mixins: [validationMixin],
  validations: {
    editedItem: {
      firstname: { required, minLength: minLength(2) },
      lastname: { required, minLength: minLength(6) },
      email: { required, email },
      phone: { required, minLength: minLength(10) },
      birthdate: { required },
      //username: { required, minLength: minLength(6) },
      password: { required, minLength: minLength(6) },
      confirm_password: { sameAsPassword: sameAs("password") },
    },
  },
  data() {
    return {
      tiers: [],
      tierId: null,
      scanQR: false,
      show: false,
      closeInSec: process.env.VUE_APP_ALERT_DISPLAY * 1000,
      absolute: true,
      dialog: false,
      dialogDelete: false,
      saleDialog: false,
      birthdate: false,
      editedItem: {},
      responseStatus: {
        alertStatus: false,
      },
      defaultItem: {
        gender: {},
      },
      gender: [
        { key: "M", value: "ชาย" },
        { key: "F", value: "หญิง" },
        { key: "N", value: "ไม่ระบุ" },
      ],
      editedIndex: -1,
      edit: false,
      term: null,
      search: "",
      searchType: "",
      payload: {},
      api_uri: process.env.VUE_APP_LOYALTY_API_URI,
      totalItems: 0,
      options: { sortBy: "createdAt", sortDesc: true },
      Clients: [],
      Client: {},
      roles: [],
      items_status: ["Active", "Inactive"],
      headers: [
        {
          value: "name",
          text: "ชื่อ นามสกุล",
        },
        {
          value: "createdAt",
          text: "วันที่ลงทะเบียน",
        },
        {
          value: "genders",
          text: "เพศ",
        },
        {
          value: "birthdate",
          text: "วันเกิด",
        },
        {
          value: "tierId.name",
          text: "เทียร์",
        },
        {
          value: "phone",
          text: "มือถือ",
        },
        {
          value: "email",
          text: "อีเมล",
        },
        {
          value: "point",
          text: "คะแนนสะสม",
        },
        {
          value: "status",
          text: "สถานะ", // this.$t("tables.headings.status")
        },
        {
          value: "actions",
          text: "Actions", // this.$t("tables.headings.actions")
        },
      ],
    };
  },
  computed: {
    /***** validation ****/
    firstnameError() {
      const errors = [];
      if (!this.$v.editedItem.firstname.$dirty && !this.edit) return errors;
      !this.$v.editedItem.firstname.minLength &&
        errors.push("ต้องมีความยาวอย่างน้อย 6 ตัวอักษร");
      !this.$v.editedItem.firstname.required && errors.push("กรุณากรอกชื่อ");
      return errors;
    },
    lastnameError() {
      const errors = [];
      if (!this.$v.editedItem.lastname.$dirty && !this.edit) return errors;
      !this.$v.editedItem.lastname.minLength &&
        errors.push("ต้องมีความยาวอย่างน้อย 6 ตัวอักษร");
      !this.$v.editedItem.lastname.required && errors.push("กรุณากรอกนามสกุล");
      return errors;
    },
    emailError() {
      const errors = [];
      if (!this.$v.editedItem.email.$dirty && !this.edit) return errors;
      !/[^@]+@[^@]+.[a-zA-Z]{2,6}/.test(this.editedItem.email) &&
        errors.push("อีเมลไม่ถูกต้อง");
      !this.$v.editedItem.email.required && errors.push("กรุณากรอกอีเมล");
      return errors;
    },

    phoneError() {
      const errors = [];
      if (!this.$v.editedItem.phone.$dirty && !this.edit) return errors;
      !/(^0)(6|8|9)[0-9]{8,8}/.test(this.editedItem.phone) &&
        errors.push("มือถือไม่ถูกต้อง ");
      !this.$v.editedItem.phone.required && errors.push("กรุณากรอกมือถือ");
      return errors;
    },
    /*
    usernameError() {
      const errors = [];
      if (!this.$v.editedItem.username.$dirty && !this.edit) return errors;
      !this.$v.editedItem.username.minLength &&
        errors.push("ต้องมีความยาวอย่างน้อย 6 ตัวอักษร");
      !this.$v.editedItem.username.required &&
        errors.push("กรุณากรอกยูสเซอร์");
      return errors;
    },
    */
    passwordError() {
      const errors = [];
      if (!this.$v.editedItem.password.$dirty && !this.edit) return errors;
      if (this.edit && this.editedItem.password.length > 0) {
        !this.$v.editedItem.password.minLength &&
          errors.push("ต้องมีความยาวอย่างน้อย 6 ตัวอักษร");
        !this.$v.editedItem.password.required && errors.push("กรุณากรอกรหัสผ่าน");
      }
      return errors;
    },

    confirmPasswordError() {
      const errors = [];
      if (!this.$v.editedItem.confirm_password.$dirty && !this.edit) return errors;
      if (this.edit && this.editedItem.password.length > 0) {
        !this.$v.editedItem.confirm_password.sameAsPassword &&
          errors.push("Password mismatch");
      }
      return errors;
    },

    /****** end validation  ****/
    ClientFilter() {
      if (this.search.length > 0) {
        return this.Clients.filter(() => {
          //return item.name.toLowerCase().startsWith(this.search.toLowerCase());
          this.readClients().then((response) => {
            this.Clients = response;
            this.totalItems = response.totalItems;
          });
        });
      } else {
        return this.Clients;
      }
    },
    formTitle() {
      return this.editedIndex === -1 ? "เพิ่ม" : "แก้ไข";
    },
  },
  mounted() {
    this.readTier();
    console.log(this.tiers);
    this.readClients().then((response) => {
      this.Clients = response;
      this.totalItems = response.totalItems;
    });
  },
  created() {
    //this.initialize();
  },
  methods: {
    clickSwitch(item) {
      console.log(item);
      this.editedIndex = this.Clients.indexOf(item);
      this.edit = this.editedIndex !== -1 ? true : false;
      item.birthdate = item.birthdate.substring(0, 10);
      item.status = item.status == null ? "Inactive" : "Active";
      this.editedItem = Object.assign({}, item);
      this.save();
    },
    async onDetected(promise) {
      console.log("onDetected");
      try {
        const {
          content, // decoded String
          //consolelocation, // QR code coordinates
        } = await promise;
        console.log(content);
        this.search = content;
        this.searchType = "id";
        this.scanQR = false;
        //alert(content);
        // console.log(location);
        // let redeem = await axios.get(this.api_uri + "/v1/redeem/code/" + content, {
        //   params: {
        //     updatedBy: sessionStorage.getItem("email"),
        //     custId: sessionStorage.getItem("custId"),
        //     apiKey: sessionStorage.getItem("apiKey"),
        //   },
        // });
        // console.log(redeem);
        // this.redeemInfo = redeem.data.data;
        // this.$store.state.redeem.pending = this.redeemInfo;
        // //this.$router.push({ name: "RedeemPending" });
        // this.dialog = true;
        // ...
      } catch (error) {
        // ...
        console.log(error);
      }
    },
    closeSaleDialog() {
      console.log("call closeSaleDialog");
      this.saleDialog = false;
      this.editedItem = {};
    },
    getColor(status) {
      //console.log(status);
      if (status == "Inactive") return "red";
      else return "green";
    },
    click(item, row) {
      console.log(item);
      console.log(row);
    },
    readClients() {
      const url = process.env.VUE_APP_LOYALTY_API_URI;
      console.log(url);
      try {
        this.payload = {
          custId: sessionStorage.getItem("custId"),
          page: this.options.page - 1,
          limit: this.options.itemsPerPage,
          filter: this.search,
          searchType: this.searchType,
        };
        return axios
          .get(
            url + "/v1/clients/list",
            { params: this.payload } // need to change
          )
          .then((response) => {
            console.log(response);
            return response.data.data.map((item) => {
              //console.log(item);

              let _tier = {
                name: "",
              };

              if (item.tierId == null) {
                item["tierId"] = _tier;
              }
              if (item.birthdate !== undefined) {
                item.birthdate.substring(10);
              } else {
                item.birthdate = "0000-00-00";
              }
              if (this.search != "") {
                //
              }
              return item;
            });
            //console.log(_Clients);
            //return _Clients;
          });
      } catch (err) {
        return (this.responseStatus = {
          status: "Error",
          code: 500,
          color: "red",
          type: "error",
          text: err,
          alertStatus: true,
        });
      }
    },
    editMember(item) {
      console.log(item);
      this.editedIndex = this.Clients.indexOf(item);
      this.edit = this.editedIndex !== -1 ? true : false;
      if (this.edit) {
        item.password = "";
      }
      item.birthdate = item.birthdate.substring(0, 10);
      if (item.tierId !== undefined && item.tierId != null) {
        this.tierId = item.tierId._id || null;
      }
      this.editedItem = Object.assign({}, item);

      this.dialog = true;
    },

    deleteItem(item) {
      this.editedIndex = this.Clients.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    async deleteItemConfirm() {
      const url = process.env.VUE_APP_LOYALTY_API_URI;
      try {
        this.payload = {
          createdBy: sessionStorage.getItem("email"),
          updatedBy: sessionStorage.getItem("email"),
          custId: sessionStorage.getItem("custId"),

          id: this.editedItem._id,
        };

        await axios
          .post(
            url + "/v1/clients/delete",
            this.payload, // need to change
            {
              headers: {
                // Overwrite Axios's automatically set Content-Type
                "Content-Type": "application/json",
                "token": sessionStorage.getItem("token"),
              },
            }
          )
          .then((response) => {
            if (response.data.ok == 1) {
              this.responseStatus = {
                status: "Success",
                code: 0,
                color: "green",
                type: "success",
                text: "บันทึกสำเร็จ",
                alertStatus: true,
              };
            }
          });
        console.log(this.Client);
        if (this.responseStatus.code == 0) {
          this.Clients.splice(this.editedIndex, 1);
          //this.readClients()
          this.totalItems--;
        }
      } catch (err) {
        return (this.responseStatus = {
          status: "Error",
          code: 500,
          color: "red",
          type: "error",
          text: err,
          alertStatus: true,
        });
      }

      this.closeDelete();
    },

    initialize() {
      const url = process.env.VUE_APP_LOYALTY_API_URI;
      console.log("initial");
      //console.log(this.permissions);
      try {
        this.payload = {
          createdBy: sessionStorage.getItem("email"),
          updatedBy: sessionStorage.getItem("email"),
          custId: sessionStorage.getItem("custId"),
          page: 0,
          limit: 99,
          filter: "",
        };
        axios
          .post(
            url + "/v1/roles/getAllRole",
            this.payload, // need to change
            {
              headers: {
                // Overwrite Axios's automatically set Content-Type
                "Content-Type": "application/json",
                "token": sessionStorage.getItem("token"),
              },
            }
          )
          .then((response) => {
            this.roles = response.data.data;
          });
      } catch (err) {
        return (this.responseStatus = {
          status: "Error",
          code: 500,
          color: "red",
          type: "error",
          text: err,
          alertStatus: true,
        });
      }
    },
    close() {
      this.dialog = false;
      this.edit = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, {});
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, {});
        this.editedIndex = -1;
      });
    },
    // timeout close overlay
    closeInTime(sec) {
      setTimeout(() => {
        this.responseStatus.alertStatus = false;
      }, sec);
    },

    addSaleOrder(item) {
      console.log(item);
      this.editedItem = item;
      console.log(this.editedItem);
      this.saleDialog = true;
    },

    // Tiers
    // listTier() {
    //   this.readTier().then((response) => {
    //     //console.log(response.data);
    //     this.tier = response.data;
    //     this.totalItems = response.totalItems;
    //   });
    // },

    async readTier() {
      const url = process.env.VUE_APP_LOYALTY_API_URI;
      try {
        this.payload = {
          custId: sessionStorage.getItem("custId"),
          page: this.options.page - 1,
          limit: this.options.itemsPerPage,
          filter: this.search,
        };
        await axios
          .get(
            url + "/v1/tier/list",
            { params: this.payload } // need to change
          )
          .then((response) => {
            console.log(response.data);
            this.tiers = response.data.data.filter((item) => {
              return item.status == "Active";
            });
            this.totalItems = response.totalItems;
          });
      } catch (err) {
        this.responseStatus = {
          status: "Error",
          code: 500,
          message: err,
        };
      }
    },

    // Save member
    async save() {
      this.$v.$touch();
      let hubspot_email =
        this.editedItem.email ||
        this.editedItem.phone + " @" + process.env.VUE_APP_DEFAULT_EMAIL_DOMAIN;
      this.payload = {
        createdBy: sessionStorage.getItem("email"),
        updatedBy: sessionStorage.getItem("email"),
        custId: sessionStorage.getItem("custId"),
        apiKey: sessionStorage.getItem("apiKey"),

        firstname: this.editedItem.firstname,
        lastname: this.editedItem.lastname,
        member_no: this.editedItem.member_no,
        email: this.editedItem.email,
        //password: this.editedItem.password,
        genders: this.editedItem.genders,
        status: this.editedItem.status,
        birthdate: this.editedItem.birthdate,

        phone: this.editedItem.phone,
        hubspot_email: hubspot_email,
        id: this.editedItem._id,
        hubspot_id: this.editedItem.hubspot_id,
        tierId: this.tierId,
      };

      if (this.editedIndex > -1) {
        console.log("update");
        const url = process.env.VUE_APP_LOYALTY_API_URI;
        try {
          console.log(this.payload);
          await axios
            .put(
              url + "/v1/clients/update",
              this.payload, // need to change
              {
                headers: {
                  // Overwrite Axios's automatically set Content-Type
                  "Content-Type": "application/json",
                  "token": sessionStorage.getItem("token"),
                },
              }
            )
            .then((response) => {
              //console.log(response.data)
              //this.Client = response.data;
              this.responseStatus = {
                status: "Success",
                code: 0,
                color: "green",
                type: "success",
                text: "Client updated",
                alertStatus: true,
                data: response.data,
              };
              //console.log(this.responseStatus)
              this.Client = response.data;

              console.log(this.Client);
              //console.log("updated");
              if (this.Client.nModified == 1) {
                Object.assign(this.Clients[this.editedIndex], this.editedItem);
              } else {
                // do something
              }
            });
        } catch (err) {
          //console.log(err)
          //return err;
          this.responseStatus = {
            status: "Error",
            code: 500,
            color: "red",
            type: "error",
            text: err,
            alertStatus: true,
          };
        }
      } else {
        const url = process.env.VUE_APP_LOYALTY_API_URI;

        try {
          // this.payload = {
          //   createdBy: sessionStorage.getItem("email"),
          //   updatedBy: sessionStorage.getItem("email"),
          //   custId: sessionStorage.getItem("custId"),
          //   apiKey: sessionStorage.getItem("apiKey"),

          //   firstname: this.editedItem.firstname,
          //   lastname: this.editedItem.lastname,
          //   email: this.editedItem.email,
          //   member_no: this.editedItem.member_no,
          //   //password: this.editedItem.password,
          //   genders: this.editedItem.genders,
          //   status: this.editedItem.status,
          //   birthdate: this.editedItem.birthdate,
          //   //gender: this.editedItem.gender,
          //   phone: this.editedItem.phone,
          //   hubspot_email: hubspot_email,
          // };
          await axios
            .post(
              url + "/v1/clients/create",
              this.payload, // need to change
              {
                headers: {
                  // Overwrite Axios's automatically set Content-Type
                  "Content-Type": "application/json",
                  "token": sessionStorage.getItem("token"),
                },
              }
            )
            .then((response) => {
              this.responseStatus = {
                status: "Success",
                code: 0,
                color: "green",
                type: "success",
                text: "Client added",
                alertStatus: true,
                data: response.data,
              };
              this.totalItems++;
            })
            .catch((error) => {
              console.log(error);
              this.responseStatus = {
                status: "Error",
                code: 500,
                color: "red",
                type: "error",
                text: error,
                alertStatus: true,
              };
            });
        } catch (err) {
          this.responseStatus = {
            status: "Error",
            code: 500,
            color: "red",
            type: "error",
            text: err,
            alertStatus: true,
          };
        }
      }
      console.log("saved");
      this.close();
    },
  },

  watch: {
    options: {
      handler() {
        console.log(this.options);
        this.payload = {
          createdBy: sessionStorage.getItem("email"),
          updatedBy: sessionStorage.getItem("email"),
          custId: sessionStorage.getItem("custId"),
          page: this.options.page - 1,
          limit: this.options.itemsPerPage,
        };

        this.readClients().then((response) => {
          this.Clients = response;
          this.totalItems = response.totalItems;
        });
      },
      deep: true,
    },

    search: {
      handler() {
        console.log("search");
        this.readClients().then((response) => {
          this.Clients = response;
          this.totalItems = response.totalItems;
        });
      },
    },
    dialog(val) {
      console.log(val);
      val || this.close();
    },
    dialogDelete(val) {
      //console.log(val);
      val || this.closeDelete();
    },
    totalItems: {
      handler() {
        //console.log(this.totalItems)
        this.readClients().then((response) => {
          this.Clients = response;
          this.totalItems = response.totalItems;
        });
      },
    },
    responseStatus: {
      handler() {
        if (this.responseStatus.alertStatus === true) {
          this.closeInTime(this.closeInSec);
        }
      },
    },
  },
};
</script>
<style scoped>
.v-data-table-header th {
  white-space: nowrap;
}
</style>
